export function defaultUniversalIntakeLinkMode(clientId) {
  return clientId ? "existing" : "new";
}
